import { styled } from '@mui/material/styles'
import { colors } from '../../constants/colors'
import { background } from '../../constants/images'
import Typography from '@mui/material/Typography';

export const BackgroundAuth = styled(`div`)(({ theme }) => ({
    backgroundColor: `${colors.white} !important`,
    height: '100vh',
    width: '100%',
    overflow: 'auto',
    display: 'flex',
    justifyContent: 'center',
    alignItems: "center",
    backgroundImage: `url(${background.loginBackground})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    color: 'unset !important',
    '& .card-text': {
        fontSize: '16px',
        textAlign: 'left'
    },
}))
export const CardAuth = styled(`div`)(({ theme }) => ({
    margin:'0px 28px',
    maxWidth: "524px",
    width:"100%",
    gap: '36px',
    padding: '60px 48px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    boxShadow: '0px 10px 15px -3px rgba(16, 24, 40, 0.10), 0px 4px 6px -4px rgba(16, 24, 40, 0.10)',
    borderRadius: 'var(--main-system-8-px, 8px)',
    borderTop: '1px solid var(--background-light-disabled, #E5E5E7)',
    borderRight: '1px solid var(--background-light-disabled, #E5E5E7)',
    borderBottom: '1px solid var(--background-light-disabled, #E5E5E7)',
    borderLeft: '1px solid var(--background-light-disabled, #E5E5E7)',
    background: 'var(--background-light-base-main, #FFF)',
}))
export const LoginAuth = styled(`img`)(({ theme }) => ({
    display: 'flex',
    width: '120px',
    height: '120px',
    justifyContent: 'center',
    alignItems: 'center',
}))
export const TitleAuth = styled(Typography)(({ theme }) => ({
    color: colors.themeMainColor,
    fontFeatureSettings: `'clig' off, 'liga' off`,
    fontFamily: 'Kanit',
    fontSize: '28px',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: '42px',
    textTransform: 'capitalize',
}))